import SubscribeCard from './SubscribeCard';

export default SubscribeCard;
